import BaseModel from '../core/BaseModel'
export default class WarrantyRepairTypeServiceModel extends BaseModel {
    constructor() {
        super({
                name: "warranty_repair_type_service",
                tableName: 'core_warranty_repair_type_service',
                display_key: 'name'
            },
            {
                code: {
                    name: 'code',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: '--',
                }
            },)
    }

}